<template>
  <div class="dropdown-selection w-160px mr-5">
    <div class="dropdown-selection-head" @click="isShow = !isShow">
      <button class="btn justify-start" style="width: 100%;" @blur="closeMenu">
        <span>篩選BU</span>
        <span class="ml-auto">
          <span v-if="isShow" key="arrow_drop_up">
            <v-icon>arrow_drop_up</v-icon>
          </span>
          <span v-if="!isShow" key="arrow_drop_down">
            <v-icon>arrow_drop_down</v-icon>
          </span>
        </span>
      </button>
    </div>
    <div class="dropdown-selection-body block w-260px" v-if="isShow">
      <div
        class="pl-10px h-48px d-flex align-center selection-item-hover"
        v-for="item in buTabs"
        :key="item"
      >
        <v-checkbox
          v-model="selectedBU"
          :value="item.id"
          class="w-100"
          @click="changeSelectBUs"
        >
          <template v-slot:label>
            <div
              class="h5 ink-01-emphasis--text h-48px d-flex align-center flex-grow-1"
            >
              {{ item.name }}
            </div>
          </template>
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedBU: [],
    isShow: false,
  }),
  computed: {
    ...mapState(['buTabs']),
  },
  watch: {
    value() {
      this.selectedBU = this.value;
    },
  },
  methods: {
    changeSelectBUs() {
      this.$emit('input', this.selectedBU);
    },
    closeMenu() {
      setTimeout(() => {
        this.isShow = false;
      }, 300);
    },
  },
};
</script>

<style></style>
